import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from '../../features/toggle/toggleSlice';
import { RootState } from '../../store';
import OpenbookIcon from '../../assets/images/open_book.svg';
import AssetsIcon from '../../assets/images/assets_icon.svg';
import { trackEvent } from '../../segment';

const ToggleComponent: React.FC = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const activeTab = useSelector((state: RootState) => state.toggle.activeTab);
    const handleTabChange = (tab: 'openBook' | 'assets') => {
        if (tab === 'openBook') {
            trackEvent('click_open_book_toggle_tab', {});
        } else {
            trackEvent('click_assets_toggle_tab', {});
        }
        const params = new URLSearchParams(location.search);
        params.set('activeTab', tab);
        dispatch(setActiveTab(tab));
        navigate(`${location.pathname}?${params.toString()}`, {
            replace: true,
        });
    };

    const isBookLibrary =
        currentPath.startsWith('/book') && currentPath !== '/book-library';

    return (
        <>
            {isBookLibrary && (
                <div className="flex">
                    <button
                        data-testid="toggle-open-book-button"
                        onClick={() => handleTabChange('openBook')}
                        className={`px-2 rounded-full h-9 w-36 transition-colors duration-300 ${
                            activeTab === 'openBook'
                                ? 'text-white z-20 mr-[-1rem]'
                                : 'bg-gray-200 text-gray-700 z-10'
                        }`}
                        style={{
                            background:
                                activeTab === 'openBook'
                                    ? 'linear-gradient(90deg, #527FED 0%, #275BDD 100%)'
                                    : '',
                        }}
                    >
                        <div className="flex px-4 items-center justify-center">
                            <img
                                src={OpenbookIcon}
                                alt="openbook icon"
                                className="h-4 w-4"
                            />
                            <p className="px-2 text-nowrap font-sans text-md">
                                Open Book
                            </p>
                        </div>
                    </button>
                    <button
                        data-testid="toggle-assets-button"
                        onClick={() => handleTabChange('assets')}
                        className={`rounded-full h-9 w-36 transition-colors duration-300 ${
                            activeTab === 'assets'
                                ? 'text-white z-20 ml-[-1rem]'
                                : 'bg-gray-200 text-gray-700 z-10'
                        }`}
                        style={{
                            background:
                                activeTab === 'assets'
                                    ? 'linear-gradient(90deg, #527FED 0%, #275BDD 100%)'
                                    : '',
                        }}
                    >
                        <div className="flex px-8 items-center">
                            <img
                                src={AssetsIcon}
                                alt="assets icon"
                                className="h-4"
                            />
                            <p className="px-2 text-nowrap font-sans text-md">
                                Assets
                            </p>
                        </div>
                    </button>
                </div>
            )}
        </>
    );
};

export default ToggleComponent;
